// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.flappy-page {
  padding: 20px;
  color: #e9ecef;
  background: radial-gradient(1200px 700px at 20% 10%, rgba(76, 201, 240, 0.10), transparent 55%),
    radial-gradient(900px 600px at 90% 0%, rgba(255, 183, 3, 0.10), transparent 55%),
    #0b1020;
  min-height: calc(100vh - 0px);
  overflow-x: hidden;
}

@media (max-width: 600px) {
  .flappy-page {
    padding: 12px;
    padding-top: max(12px, env(safe-area-inset-top));
    padding-left: max(12px, env(safe-area-inset-left));
    padding-right: max(12px, env(safe-area-inset-right));
    padding-bottom: max(16px, env(safe-area-inset-bottom));
  }
}

.flappy-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 16px;
}

@media (max-width: 600px) {
  .flappy-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

.flappy-title {
  margin: 0;
  font-size: 26px;
}

@media (max-width: 600px) {
  .flappy-title {
    font-size: 22px;
  }
}

.flappy-subtitle {
  margin-top: 6px;
  color: rgba(233, 236, 239, 0.70);
  font-size: 14px;
}

.flappy-header-actions {
  display: flex;
  gap: 10px;
}

@media (max-width: 600px) {
  .flappy-header-actions {
    width: 100%;
    flex-wrap: wrap;
  }

  .flappy-header-actions .flappy-btn,
  .flappy-header-actions .flappy-btn-primary {
    flex: 1 1;
    min-width: 120px;
  }
}

.flappy-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
}

@media (min-width: 980px) {
  .flappy-grid {
    grid-template-columns: 420px 1fr;
    align-items: start;
  }
}

.flappy-card {
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 14px;
  padding: 16px;
  backdrop-filter: blur(10px);
}

.flappy-card h2 {
  margin: 0 0 10px 0;
  font-size: 18px;
}

.flappy-row {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 12px;
  align-items: center;
  margin-bottom: 10px;
}

@media (max-width: 600px) {
  .flappy-row {
    grid-template-columns: 1fr;
    gap: 6px;
  }
}

.flappy-label {
  color: rgba(233, 236, 239, 0.75);
}

.flappy-input {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.10);
  border-radius: 10px;
  padding: 10px 12px;
  color: #e9ecef;
  outline: none;
}

.flappy-input:focus {
  border-color: rgba(76, 201, 240, 0.55);
}

.flappy-meta {
  display: grid;
  gap: 6px;
  color: rgba(233, 236, 239, 0.82);
  margin-bottom: 12px;
}

.flappy-btn,
.flappy-btn-primary {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.10);
  color: #e9ecef;
  border-radius: 10px;
  padding: 10px 12px;
  cursor: pointer;
  touch-action: manipulation;
}

@media (max-width: 600px) {

  .flappy-btn,
  .flappy-btn-primary {
    padding: 12px 14px;
    font-size: 15px;
  }
}

.flappy-btn:hover {
  background: rgba(255, 255, 255, 0.10);
}

.flappy-btn:disabled,
.flappy-btn-primary:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.flappy-btn-primary {
  background: linear-gradient(135deg, rgba(76, 201, 240, 0.35), rgba(255, 183, 3, 0.25));
  border-color: rgba(76, 201, 240, 0.40);
}

.flappy-error {
  background: rgba(255, 0, 0, 0.08);
  border: 1px solid rgba(255, 0, 0, 0.20);
  padding: 10px 12px;
  border-radius: 12px;
  margin: 10px 0 14px;
  color: rgba(255, 255, 255, 0.92);
}

.flappy-hint {
  margin-top: 10px;
  color: rgba(233, 236, 239, 0.72);
  font-size: 13px;
}

.flappy-start-spotlight,
.cm-start-spotlight {
  display: grid;
  justify-items: center;
  gap: 8px;
  margin: 12px auto 10px;
  padding: 12px 14px;
  max-width: 300px;
  text-align: center;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  background:
    radial-gradient(circle at top, rgba(251, 191, 36, 0.16), transparent 58%),
    rgba(255, 255, 255, 0.04);
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
}

.flappy-start-spotlight__title,
.cm-start-spotlight__title {
  font-size: 0.86rem;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.94);
}

.flappy-start-spotlight__sub,
.cm-start-spotlight__sub {
  font-size: 0.74rem;
  line-height: 1.35;
  color: rgba(233, 236, 239, 0.76);
}

.flappy-start-spotlight .flappy-btn-primary,
.cm-start-spotlight .cm-btn--primary {
  min-width: min(170px, 100%);
  padding: 9px 16px;
  font-size: 0.84rem;
  font-weight: 700;
  border-radius: 999px;
  box-shadow: 0 8px 18px rgba(251, 191, 36, 0.18);
}

.flappy-canvas-wrap {
  position: relative;
  width: 100%;
  max-width: 820px;
}

.flappy-canvas {
  width: 100%;
  height: auto;
  touch-action: none;
  -webkit-tap-highlight-color: transparent;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  display: block;
  background: #0b1320;
}

.flappy-rotate-overlay {
  position: absolute;
  inset: 0;
  display: none;
  align-items: center;
  justify-content: center;
  padding: 16px;
  border-radius: 12px;
  background: rgba(6, 10, 20, 0.72);
  text-align: center;
  z-index: 2;
}

.flappy-rotate-card {
  padding: 14px 16px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  background: rgba(0, 0, 0, 0.35);
}

.flappy-rotate-title {
  font-weight: 700;
  color: #f8f9fa;
}

.flappy-rotate-sub {
  margin-top: 6px;
  font-size: 12px;
  color: rgba(233, 236, 239, 0.72);
}

.flappy-canvas-instructions {
  color: rgba(255, 255, 255, 0.85);
  font-size: 13px;
}

.flappy-canvas-subtext {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
}

.flappy-canvas-controls {
  display: flex;
  gap: 10px;
  align-items: center;
}

.flappy-canvas-status {
  color: rgba(255, 255, 255, 0.75);
  font-size: 13px;
}

.flappy-canvas-hud {
  color: rgba(255, 255, 255, 0.6);
  font-size: 12px;
}

@media (max-width: 900px) and (orientation: portrait) {
  .flappy-rotate-overlay {
    display: flex;
  }
}

@media (max-width: 600px) {
  .flappy-canvas-wrap {
    max-width: none;
  }

  .flappy-canvas-controls {
    display: none;
  }

  .flappy-canvas-instructions,
  .flappy-canvas-subtext,
  .flappy-canvas-hud {
    display: none;
  }
}

.flappy-list {
  display: grid;
  gap: 10px;
}

.flappy-list-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  background: rgba(255, 255, 255, 0.03);
}

@media (max-width: 600px) {
  .flappy-list-item {
    flex-direction: column;
    align-items: stretch;
  }

  .flappy-list-item button {
    width: 100%;
  }
}

.flappy-list-title {
  font-weight: 700;
}

.flappy-pill {
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  padding: 3px 8px;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
  border: 1px solid rgba(255, 255, 255, 0.18);
  background: rgba(0, 0, 0, 0.25);
}

.flappy-pill--bet {
  background: rgba(239, 68, 68, 0.18);
  border-color: rgba(239, 68, 68, 0.45);
  color: #fecaca;
}

.flappy-pill--friendly {
  background: rgba(34, 197, 94, 0.18);
  border-color: rgba(34, 197, 94, 0.45);
  color: #bbf7d0;
}

.flappy-list-sub {
  font-size: 12px;
  color: rgba(233, 236, 239, 0.68);
  margin-top: 2px;
}


/* =========================================================
   CHESS MATCH - Chess.com-style tight single-column layout
   ========================================================= */

.chess-match-page {
  display: flex;
  flex-direction: column;
  height: 100vh;
  height: 100dvh;
  background: #262421;
  color: #e8e6e3;
  overflow: hidden;
  padding: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  margin: 0 auto;
  align-items: center;
}

/* -- Topbar -- */
.cm-topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  padding: 4px 8px;
  background: #1f1d1a;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  flex: 0 0 auto;
  min-height: 40px;
}

.cm-topbar-center {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  justify-content: center;
  min-width: 0;
}

.cm-topbar-title {
  font-weight: 700;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cm-badge {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 7px;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.72);
  white-space: nowrap;
  text-transform: capitalize;
}

.cm-badge--gold {
  background: rgba(255, 183, 3, 0.18);
  color: #ffd666;
}

.cm-badge--review {
  background: rgba(96, 165, 250, 0.2);
  color: #bfdbfe;
}

.cm-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 7px;
  border: none;
  background: rgba(255, 255, 255, 0.06);
  color: #e8e6e3;
  font-size: 16px;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}

.cm-icon-btn:hover {
  background: rgba(255, 255, 255, 0.12);
}

/* -- Toast -- */
.cm-toast {
  padding: 5px 12px;
  font-size: 12px;
  text-align: center;
  flex-shrink: 0;
}

.cm-toast--error {
  background: rgba(220, 38, 38, 0.22);
  color: #fca5a5;
}

/* -- Game stack: opponent bar + board + my bar, centered horizontally and vertically -- */
.cm-game-stack {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1 1 auto;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin: 0 auto;
}

/* -- Player bar: SAME WIDTH as board, directly flanking it, zero gap -- */
.cm-player-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: var(--board-size, 320px);
  max-width: 100%;
  height: 52px;
  padding: 6px 10px;
  gap: 8px;
  background: #1f1d1a;
  flex: 0 0 auto;
  transition: background 0.2s;
  margin: 0 auto;
}

.cm-player-bar--active {
  background: #2a2826;
}

.cm-player-bar__info {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
}

.cm-player-bar__avatar {
  width: 28px;
  height: 28px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  flex-shrink: 0;
}

.cm-player-bar__meta {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  overflow: hidden;
  flex-wrap: wrap;
}

.cm-player-bar__name {
  font-weight: 700;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.cm-player-bar__rating {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
  white-space: nowrap;
  flex-shrink: 0;
}

.cm-captured-row {
  display: flex;
  align-items: center;
  gap: 1px;
  overflow: hidden;
  flex-shrink: 1;
}

.cm-captured-piece {
  font-size: 12px;
  line-height: 1;
  opacity: 0.72;
}

.cm-captured-diff {
  margin-left: 2px;
  font-size: 10px;
  font-weight: 800;
  color: #9be37f;
}

.cm-turn-chip {
  padding: 2px 7px;
  border-radius: 999px;
  background: rgba(129, 182, 76, 0.2);
  font-size: 10px;
  color: #bef264;
  white-space: nowrap;
  flex-shrink: 0;
}

.cm-clock {
  font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;
  font-weight: 700;
  font-size: 18px;
  line-height: 1.2;
  background: #000;
  color: #d4d4d4;
  padding: 6px 10px;
  border-radius: 4px;
  min-width: 72px;
  text-align: center;
  flex-shrink: 0;
  letter-spacing: 0.02em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.cm-clock--ticking {
  background: #86efac;
  color: #042f0f;
}

/* -- Board wrap: exact square, no flex stretch -- */
.cm-board-wrap {
  position: relative;
  width: var(--board-size, 320px);
  height: var(--board-size, 320px);
  max-width: 100%;
  flex: 0 0 auto;
  background: #302e2b;
  overflow: hidden;
  margin: 0 auto;
}

.cm-loading {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.3);
  z-index: 5;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
}

/* -- Promotion overlay -- */
.cm-promo-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.55);
  z-index: 10;
  backdrop-filter: blur(4px);
}

.cm-promo-dialog {
  background: #3b3936;
  border-radius: 12px;
  padding: 14px 18px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);
}

.cm-promo-title {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
}

.cm-promo-options {
  display: flex;
  gap: 8px;
}

.cm-promo-btn {
  width: 48px;
  height: 48px;
  border-radius: 9px;
  border: 2px solid rgba(255, 255, 255, 0.12);
  background: #272522;
  color: #e8e6e3;
  font-size: 26px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s;
}

.cm-promo-btn:hover {
  background: #4a4745;
  border-color: rgba(134, 239, 172, 0.5);
}

.cm-promo-btn--cancel {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.4);
}

.cm-promo-btn--cancel:hover {
  color: #fca5a5;
  border-color: rgba(252, 165, 165, 0.4);
}

/* -- Result banner -- */
.cm-result-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 6px 12px;
  flex: 0 0 auto;
  flex-wrap: wrap;
  text-align: center;
  font-size: 13px;
  font-weight: 600;
}

.cm-result-banner--win {
  background: rgba(34, 197, 94, 0.18);
  color: #86efac;
}

.cm-result-banner--loss {
  background: rgba(239, 68, 68, 0.18);
  color: #fca5a5;
}

.cm-result-banner--draw {
  background: rgba(251, 191, 36, 0.15);
  color: #fde68a;
}

.cm-result-banner__icon {
  font-size: 16px;
}

.cm-result-banner__payout {
  font-size: 11px;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.5);
  flex-basis: 100%;
}

/* -- Moves strip: horizontal scroll, below board -- */
.cm-moves-strip {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: #1f1d1a;
  border-top: 1px solid rgba(255, 255, 255, 0.04);
  flex: 0 0 auto;
  min-height: 28px;
  scrollbar-width: none;
  max-width: 100%;
  margin: 0 auto;
  width: var(--board-size, 320px);
}

.cm-moves-strip::-webkit-scrollbar {
  display: none;
}

.cm-moves-empty {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  white-space: nowrap;
  padding-left: 2px;
}

.cm-moves-pair {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  gap: 2px;
}

.cm-moves-num {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.35);
  font-weight: 600;
  white-space: nowrap;
}

.cm-moves-san {
  font-size: 12px;
  font-weight: 600;
  color: #e8e6e3;
  padding: 2px 6px;
  border-radius: 4px;
  border: none;
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: background 0.1s;
}

.cm-moves-san:hover {
  background: rgba(255, 255, 255, 0.07);
}

.cm-moves-san--black {
  color: rgba(232, 230, 227, 0.68);
}

.cm-moves-san--active {
  background: rgba(129, 182, 76, 0.25);
  color: #f7f6f2;
}

/* -- Status line -- */
.cm-status-line {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 3px 8px;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.55);
  background: #1f1d1a;
  flex: 0 0 auto;
}

.cm-status-line:empty {
  display: none;
  padding: 0;
}

.cm-link-btn {
  background: none;
  border: none;
  color: #93c5fd;
  cursor: pointer;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 4px;
}

.cm-link-btn:hover {
  background: rgba(147, 197, 253, 0.1);
}

.cm-icon-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.08);
  color: #f7f6f2;
  font-size: 15px;
}

.cm-icon-pill--start {
  background: #81b64c;
}

/* -- Action buttons: horizontal scroll row -- */
.cm-actions {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  gap: 5px;
  padding: 5px 8px;
  background: #1f1d1a;
  flex: 0 0 auto;
  scrollbar-width: none;
  max-width: 100%;
  margin: 0 auto;
  width: var(--board-size, 320px);
}

.cm-actions::-webkit-scrollbar {
  display: none;
}

.cm-actions:empty {
  display: none;
  padding: 0;
  width: auto;
}

.cm-btn {
  flex-shrink: 0;
  padding: 6px 11px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s;
}

.cm-btn--primary {
  background: #81b64c;
  color: #fff;
}

.cm-btn--primary:hover {
  background: #6fa23e;
}

.cm-btn--primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.cm-btn--ghost {
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.75);
}

.cm-btn--ghost:hover {
  background: rgba(255, 255, 255, 0.12);
}

.cm-btn--danger {
  background: rgba(220, 38, 38, 0.2);
  color: #fca5a5;
}

.cm-btn--danger:hover {
  background: rgba(220, 38, 38, 0.35);
}

.cm-btn--outline {
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(255, 255, 255, 0.15);
}

/* -- Review dock: bottom row (chat + ‹ LIVE ›) -- */
.cm-review-dock {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  padding: 4px 8px max(6px, env(safe-area-inset-bottom));
  background: #1f1d1a;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  flex: 0 0 auto;
}

.cm-dock-btn {
  position: relative;
  flex: 1 1;
  min-height: 34px;
  border-radius: 6px;
  border: 1px solid rgba(255, 255, 255, 0.07);
  background: rgba(255, 255, 255, 0.05);
  color: #f7f6f2;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  overflow: hidden;
}

.cm-dock-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.cm-dock-btn--live {
  font-size: 11px;
  letter-spacing: 0.04em;
}

.cm-dock-btn--active {
  background: #81b64c;
  color: #fff;
}

.cm-dock-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  min-width: 16px;
  height: 16px;
  border-radius: 999px;
  background: #ef4444;
  color: #fff;
  font-size: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
}

/* -- Small-screen tightening -- */
@media (max-width: 480px) {
  .cm-topbar {
    min-height: 36px;
    padding: 3px 6px;
  }

  .cm-icon-btn {
    width: 28px;
    height: 28px;
    font-size: 14px;
  }

  .cm-topbar-title {
    font-size: 12px;
  }

  .cm-player-bar {
    height: 46px;
    padding: 5px 8px;
  }

  .cm-player-bar__avatar {
    width: 24px;
    height: 24px;
    font-size: 14px;
  }

  .cm-player-bar__name {
    font-size: 12px;
    max-width: 110px;
  }

  .cm-clock {
    font-size: 15px;
    min-width: 60px;
    padding: 3px 7px;
  }

  .cm-btn {
    font-size: 11px;
    padding: 5px 9px;
  }

  .cm-dock-btn {
    min-height: 30px;
    font-size: 14px;
  }

  .cm-moves-strip {
    min-height: 24px;
    padding: 3px 6px;
  }

  .cm-game-stack {
    width: 100%;
    max-width: 100%;
    padding: 0;
    overflow-x: hidden;
  }

  .cm-board-wrap {
    max-width: calc(100vw - 8px);
    width: var(--board-size, 320px);
    margin: 0 auto;
  }

  .cm-player-bar {
    max-width: calc(100vw - 8px);
    width: var(--board-size, 320px);
    margin: 0 auto;
  }

  .cm-moves-strip {
    max-width: 100%;
    overflow-x: auto;
  }

  .cm-actions {
    max-width: 100%;
    overflow-x: auto;
  }
}

@media (max-width: 360px) {
  .cm-player-bar {
    height: 44px;
    padding: 4px 6px;
  }

  .cm-player-bar__avatar {
    width: 22px;
    height: 22px;
    font-size: 13px;
  }

  .cm-player-bar__name {
    font-size: 11px;
    max-width: 90px;
  }

  .cm-clock {
    font-size: 14px;
    min-width: 54px;
    padding: 2px 6px;
  }

  .cm-btn {
    font-size: 10px;
    padding: 4px 8px;
  }

  .chess-match-page {
    align-items: center;
    padding: 0;
  }

  .cm-game-stack {
    width: 100%;
    padding: 0;
  }

  .cm-board-wrap,
  .cm-player-bar,
  .cm-moves-strip,
  .cm-actions {
    max-width: calc(100vw - 8px);
    width: var(--board-size, 280px);
    margin-left: auto;
    margin-right: auto;
  }
}

/* -- Spotlight (shared with flappy) -- */
.flappy-start-spotlight,
.cm-start-spotlight {
  display: grid;
  justify-items: center;
  gap: 8px;
  margin: 10px auto;
  padding: 10px 12px;
  max-width: 300px;
  text-align: center;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.10);
  background:
    radial-gradient(circle at top, rgba(251, 191, 36, 0.13), transparent 56%),
    rgba(255, 255, 255, 0.03);
  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);
}

.flappy-start-spotlight__title,
.cm-start-spotlight__title {
  font-size: 0.84rem;
  font-weight: 800;
  color: rgba(255, 255, 255, 0.94);
}

.flappy-start-spotlight__sub,
.cm-start-spotlight__sub {
  font-size: 0.72rem;
  line-height: 1.35;
  color: rgba(233, 236, 239, 0.72);
}

.flappy-start-spotlight .flappy-btn-primary,
.cm-start-spotlight .cm-btn--primary {
  min-width: min(160px, 100%);
  padding: 8px 14px;
  font-size: 0.83rem;
  font-weight: 700;
  border-radius: 999px;
}

@media (max-width: 600px) {

  .flappy-start-spotlight,
  .cm-start-spotlight {
    margin: 8px auto;
    padding: 9px 11px;
  }

  .cm-start-spotlight .cm-btn--primary {
    width: auto;
    min-width: 140px;
  }
}

/* Legacy layout stubs */
.chess-layout,
.chess-panel,
.chess-board-panel,
.chess-board-shell,
.chess-board-inner,
.chess-mobile-timer,
.chess-info-panel,
.chess-moves-panel {}`, "",{"version":3,"sources":["webpack://./src/styles/Flappy.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,cAAc;EACd;;WAES;EACT,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;IACb,gDAAgD;IAChD,kDAAkD;IAClD,oDAAoD;IACpD,sDAAsD;EACxD;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;;IAEE,SAAO;IACP,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE;IACE,gCAAgC;IAChC,kBAAkB;EACpB;AACF;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,QAAQ;EACV;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;;EAEE,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;EAEE;;IAEE,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,sFAAsF;EACtF,sCAAsC;AACxC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C;;6BAE2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,aAAa;EACf;AACF;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;AACvC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,eAAe;AACjB;;;AAGA;;8DAE8D;;AAE9D;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,8EAA8E;EAC9E,cAAc;EACd,mBAAmB;AACrB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,kDAAkD;EAClD,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gCAAgC;EAChC,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA,0FAA0F;AAC1F;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,YAAY;EACZ,WAAW;EACX,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;EAC/B,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,mCAAmC;EACnC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0DAA0D;EAC1D,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oDAAoD;AACpD;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,UAAU;EACV,eAAe;EACf,+BAA+B;AACjC;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,+CAA+C;EAC/C,cAAc;EACd,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,UAAU;EACV,WAAW;AACb;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,2CAA2C;AAC7C;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,sDAAsD;EACtD,mBAAmB;EACnB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;EAChB;;EAEA;IACE,4BAA4B;IAC5B,+BAA+B;IAC/B,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,UAAU;EACZ;;EAEA;;;;IAIE,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,yCAAyC;AACzC;;EAEE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C;;6BAE2B;EAC3B,2CAA2C;AAC7C;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;;EAEE,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;EAEE;;IAEE,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;;;;;;;oBAOoB","sourcesContent":[".flappy-page {\n  padding: 20px;\n  color: #e9ecef;\n  background: radial-gradient(1200px 700px at 20% 10%, rgba(76, 201, 240, 0.10), transparent 55%),\n    radial-gradient(900px 600px at 90% 0%, rgba(255, 183, 3, 0.10), transparent 55%),\n    #0b1020;\n  min-height: calc(100vh - 0px);\n  overflow-x: hidden;\n}\n\n@media (max-width: 600px) {\n  .flappy-page {\n    padding: 12px;\n    padding-top: max(12px, env(safe-area-inset-top));\n    padding-left: max(12px, env(safe-area-inset-left));\n    padding-right: max(12px, env(safe-area-inset-right));\n    padding-bottom: max(16px, env(safe-area-inset-bottom));\n  }\n}\n\n.flappy-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 16px;\n}\n\n@media (max-width: 600px) {\n  .flappy-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n\n.flappy-title {\n  margin: 0;\n  font-size: 26px;\n}\n\n@media (max-width: 600px) {\n  .flappy-title {\n    font-size: 22px;\n  }\n}\n\n.flappy-subtitle {\n  margin-top: 6px;\n  color: rgba(233, 236, 239, 0.70);\n  font-size: 14px;\n}\n\n.flappy-header-actions {\n  display: flex;\n  gap: 10px;\n}\n\n@media (max-width: 600px) {\n  .flappy-header-actions {\n    width: 100%;\n    flex-wrap: wrap;\n  }\n\n  .flappy-header-actions .flappy-btn,\n  .flappy-header-actions .flappy-btn-primary {\n    flex: 1;\n    min-width: 120px;\n  }\n}\n\n.flappy-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 16px;\n}\n\n@media (min-width: 980px) {\n  .flappy-grid {\n    grid-template-columns: 420px 1fr;\n    align-items: start;\n  }\n}\n\n.flappy-card {\n  background: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 14px;\n  padding: 16px;\n  backdrop-filter: blur(10px);\n}\n\n.flappy-card h2 {\n  margin: 0 0 10px 0;\n  font-size: 18px;\n}\n\n.flappy-row {\n  display: grid;\n  grid-template-columns: 120px 1fr;\n  gap: 12px;\n  align-items: center;\n  margin-bottom: 10px;\n}\n\n@media (max-width: 600px) {\n  .flappy-row {\n    grid-template-columns: 1fr;\n    gap: 6px;\n  }\n}\n\n.flappy-label {\n  color: rgba(233, 236, 239, 0.75);\n}\n\n.flappy-input {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  border-radius: 10px;\n  padding: 10px 12px;\n  color: #e9ecef;\n  outline: none;\n}\n\n.flappy-input:focus {\n  border-color: rgba(76, 201, 240, 0.55);\n}\n\n.flappy-meta {\n  display: grid;\n  gap: 6px;\n  color: rgba(233, 236, 239, 0.82);\n  margin-bottom: 12px;\n}\n\n.flappy-btn,\n.flappy-btn-primary {\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  color: #e9ecef;\n  border-radius: 10px;\n  padding: 10px 12px;\n  cursor: pointer;\n  touch-action: manipulation;\n}\n\n@media (max-width: 600px) {\n\n  .flappy-btn,\n  .flappy-btn-primary {\n    padding: 12px 14px;\n    font-size: 15px;\n  }\n}\n\n.flappy-btn:hover {\n  background: rgba(255, 255, 255, 0.10);\n}\n\n.flappy-btn:disabled,\n.flappy-btn-primary:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.flappy-btn-primary {\n  background: linear-gradient(135deg, rgba(76, 201, 240, 0.35), rgba(255, 183, 3, 0.25));\n  border-color: rgba(76, 201, 240, 0.40);\n}\n\n.flappy-error {\n  background: rgba(255, 0, 0, 0.08);\n  border: 1px solid rgba(255, 0, 0, 0.20);\n  padding: 10px 12px;\n  border-radius: 12px;\n  margin: 10px 0 14px;\n  color: rgba(255, 255, 255, 0.92);\n}\n\n.flappy-hint {\n  margin-top: 10px;\n  color: rgba(233, 236, 239, 0.72);\n  font-size: 13px;\n}\n\n.flappy-start-spotlight,\n.cm-start-spotlight {\n  display: grid;\n  justify-items: center;\n  gap: 8px;\n  margin: 12px auto 10px;\n  padding: 12px 14px;\n  max-width: 300px;\n  text-align: center;\n  border-radius: 14px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  background:\n    radial-gradient(circle at top, rgba(251, 191, 36, 0.16), transparent 58%),\n    rgba(255, 255, 255, 0.04);\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);\n}\n\n.flappy-start-spotlight__title,\n.cm-start-spotlight__title {\n  font-size: 0.86rem;\n  font-weight: 800;\n  color: rgba(255, 255, 255, 0.94);\n}\n\n.flappy-start-spotlight__sub,\n.cm-start-spotlight__sub {\n  font-size: 0.74rem;\n  line-height: 1.35;\n  color: rgba(233, 236, 239, 0.76);\n}\n\n.flappy-start-spotlight .flappy-btn-primary,\n.cm-start-spotlight .cm-btn--primary {\n  min-width: min(170px, 100%);\n  padding: 9px 16px;\n  font-size: 0.84rem;\n  font-weight: 700;\n  border-radius: 999px;\n  box-shadow: 0 8px 18px rgba(251, 191, 36, 0.18);\n}\n\n.flappy-canvas-wrap {\n  position: relative;\n  width: 100%;\n  max-width: 820px;\n}\n\n.flappy-canvas {\n  width: 100%;\n  height: auto;\n  touch-action: none;\n  -webkit-tap-highlight-color: transparent;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  display: block;\n  background: #0b1320;\n}\n\n.flappy-rotate-overlay {\n  position: absolute;\n  inset: 0;\n  display: none;\n  align-items: center;\n  justify-content: center;\n  padding: 16px;\n  border-radius: 12px;\n  background: rgba(6, 10, 20, 0.72);\n  text-align: center;\n  z-index: 2;\n}\n\n.flappy-rotate-card {\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  background: rgba(0, 0, 0, 0.35);\n}\n\n.flappy-rotate-title {\n  font-weight: 700;\n  color: #f8f9fa;\n}\n\n.flappy-rotate-sub {\n  margin-top: 6px;\n  font-size: 12px;\n  color: rgba(233, 236, 239, 0.72);\n}\n\n.flappy-canvas-instructions {\n  color: rgba(255, 255, 255, 0.85);\n  font-size: 13px;\n}\n\n.flappy-canvas-subtext {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n}\n\n.flappy-canvas-controls {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.flappy-canvas-status {\n  color: rgba(255, 255, 255, 0.75);\n  font-size: 13px;\n}\n\n.flappy-canvas-hud {\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 12px;\n}\n\n@media (max-width: 900px) and (orientation: portrait) {\n  .flappy-rotate-overlay {\n    display: flex;\n  }\n}\n\n@media (max-width: 600px) {\n  .flappy-canvas-wrap {\n    max-width: none;\n  }\n\n  .flappy-canvas-controls {\n    display: none;\n  }\n\n  .flappy-canvas-instructions,\n  .flappy-canvas-subtext,\n  .flappy-canvas-hud {\n    display: none;\n  }\n}\n\n.flappy-list {\n  display: grid;\n  gap: 10px;\n}\n\n.flappy-list-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  background: rgba(255, 255, 255, 0.03);\n}\n\n@media (max-width: 600px) {\n  .flappy-list-item {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .flappy-list-item button {\n    width: 100%;\n  }\n}\n\n.flappy-list-title {\n  font-weight: 700;\n}\n\n.flappy-pill {\n  display: inline-flex;\n  align-items: center;\n  margin-left: 8px;\n  padding: 3px 8px;\n  border-radius: 999px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  border: 1px solid rgba(255, 255, 255, 0.18);\n  background: rgba(0, 0, 0, 0.25);\n}\n\n.flappy-pill--bet {\n  background: rgba(239, 68, 68, 0.18);\n  border-color: rgba(239, 68, 68, 0.45);\n  color: #fecaca;\n}\n\n.flappy-pill--friendly {\n  background: rgba(34, 197, 94, 0.18);\n  border-color: rgba(34, 197, 94, 0.45);\n  color: #bbf7d0;\n}\n\n.flappy-list-sub {\n  font-size: 12px;\n  color: rgba(233, 236, 239, 0.68);\n  margin-top: 2px;\n}\n\n\n/* =========================================================\n   CHESS MATCH - Chess.com-style tight single-column layout\n   ========================================================= */\n\n.chess-match-page {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  height: 100dvh;\n  background: #262421;\n  color: #e8e6e3;\n  overflow: hidden;\n  padding: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  margin: 0 auto;\n  align-items: center;\n}\n\n/* -- Topbar -- */\n.cm-topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 6px;\n  padding: 4px 8px;\n  background: #1f1d1a;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n  flex: 0 0 auto;\n  min-height: 40px;\n}\n\n.cm-topbar-center {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  justify-content: center;\n  min-width: 0;\n}\n\n.cm-topbar-title {\n  font-weight: 700;\n  font-size: 13px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cm-badge {\n  font-size: 10px;\n  font-weight: 600;\n  padding: 2px 7px;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.72);\n  white-space: nowrap;\n  text-transform: capitalize;\n}\n\n.cm-badge--gold {\n  background: rgba(255, 183, 3, 0.18);\n  color: #ffd666;\n}\n\n.cm-badge--review {\n  background: rgba(96, 165, 250, 0.2);\n  color: #bfdbfe;\n}\n\n.cm-icon-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 7px;\n  border: none;\n  background: rgba(255, 255, 255, 0.06);\n  color: #e8e6e3;\n  font-size: 16px;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n\n.cm-icon-btn:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n/* -- Toast -- */\n.cm-toast {\n  padding: 5px 12px;\n  font-size: 12px;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.cm-toast--error {\n  background: rgba(220, 38, 38, 0.22);\n  color: #fca5a5;\n}\n\n/* -- Game stack: opponent bar + board + my bar, centered horizontally and vertically -- */\n.cm-game-stack {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 auto;\n  min-height: 0;\n  min-width: 0;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin: 0 auto;\n}\n\n/* -- Player bar: SAME WIDTH as board, directly flanking it, zero gap -- */\n.cm-player-bar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: var(--board-size, 320px);\n  max-width: 100%;\n  height: 52px;\n  padding: 6px 10px;\n  gap: 8px;\n  background: #1f1d1a;\n  flex: 0 0 auto;\n  transition: background 0.2s;\n  margin: 0 auto;\n}\n\n.cm-player-bar--active {\n  background: #2a2826;\n}\n\n.cm-player-bar__info {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n}\n\n.cm-player-bar__avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 18px;\n  flex-shrink: 0;\n}\n\n.cm-player-bar__meta {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  min-width: 0;\n  overflow: hidden;\n  flex-wrap: wrap;\n}\n\n.cm-player-bar__name {\n  font-weight: 700;\n  font-size: 14px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 140px;\n}\n\n.cm-player-bar__rating {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.55);\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.cm-captured-row {\n  display: flex;\n  align-items: center;\n  gap: 1px;\n  overflow: hidden;\n  flex-shrink: 1;\n}\n\n.cm-captured-piece {\n  font-size: 12px;\n  line-height: 1;\n  opacity: 0.72;\n}\n\n.cm-captured-diff {\n  margin-left: 2px;\n  font-size: 10px;\n  font-weight: 800;\n  color: #9be37f;\n}\n\n.cm-turn-chip {\n  padding: 2px 7px;\n  border-radius: 999px;\n  background: rgba(129, 182, 76, 0.2);\n  font-size: 10px;\n  color: #bef264;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.cm-clock {\n  font-family: 'SF Mono', 'Fira Code', 'Consolas', monospace;\n  font-weight: 700;\n  font-size: 18px;\n  line-height: 1.2;\n  background: #000;\n  color: #d4d4d4;\n  padding: 6px 10px;\n  border-radius: 4px;\n  min-width: 72px;\n  text-align: center;\n  flex-shrink: 0;\n  letter-spacing: 0.02em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.cm-clock--ticking {\n  background: #86efac;\n  color: #042f0f;\n}\n\n/* -- Board wrap: exact square, no flex stretch -- */\n.cm-board-wrap {\n  position: relative;\n  width: var(--board-size, 320px);\n  height: var(--board-size, 320px);\n  max-width: 100%;\n  flex: 0 0 auto;\n  background: #302e2b;\n  overflow: hidden;\n  margin: 0 auto;\n}\n\n.cm-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.3);\n  z-index: 5;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* -- Promotion overlay -- */\n.cm-promo-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.55);\n  z-index: 10;\n  backdrop-filter: blur(4px);\n}\n\n.cm-promo-dialog {\n  background: #3b3936;\n  border-radius: 12px;\n  padding: 14px 18px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 10px;\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.5);\n}\n\n.cm-promo-title {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.cm-promo-options {\n  display: flex;\n  gap: 8px;\n}\n\n.cm-promo-btn {\n  width: 48px;\n  height: 48px;\n  border-radius: 9px;\n  border: 2px solid rgba(255, 255, 255, 0.12);\n  background: #272522;\n  color: #e8e6e3;\n  font-size: 26px;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.15s;\n}\n\n.cm-promo-btn:hover {\n  background: #4a4745;\n  border-color: rgba(134, 239, 172, 0.5);\n}\n\n.cm-promo-btn--cancel {\n  font-size: 16px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.cm-promo-btn--cancel:hover {\n  color: #fca5a5;\n  border-color: rgba(252, 165, 165, 0.4);\n}\n\n/* -- Result banner -- */\n.cm-result-banner {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 6px 12px;\n  flex: 0 0 auto;\n  flex-wrap: wrap;\n  text-align: center;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.cm-result-banner--win {\n  background: rgba(34, 197, 94, 0.18);\n  color: #86efac;\n}\n\n.cm-result-banner--loss {\n  background: rgba(239, 68, 68, 0.18);\n  color: #fca5a5;\n}\n\n.cm-result-banner--draw {\n  background: rgba(251, 191, 36, 0.15);\n  color: #fde68a;\n}\n\n.cm-result-banner__icon {\n  font-size: 16px;\n}\n\n.cm-result-banner__payout {\n  font-size: 11px;\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.5);\n  flex-basis: 100%;\n}\n\n/* -- Moves strip: horizontal scroll, below board -- */\n.cm-moves-strip {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  overflow-y: hidden;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: #1f1d1a;\n  border-top: 1px solid rgba(255, 255, 255, 0.04);\n  flex: 0 0 auto;\n  min-height: 28px;\n  scrollbar-width: none;\n  max-width: 100%;\n  margin: 0 auto;\n  width: var(--board-size, 320px);\n}\n\n.cm-moves-strip::-webkit-scrollbar {\n  display: none;\n}\n\n.cm-moves-empty {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.35);\n  white-space: nowrap;\n  padding-left: 2px;\n}\n\n.cm-moves-pair {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n  gap: 2px;\n}\n\n.cm-moves-num {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.35);\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.cm-moves-san {\n  font-size: 12px;\n  font-weight: 600;\n  color: #e8e6e3;\n  padding: 2px 6px;\n  border-radius: 4px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: background 0.1s;\n}\n\n.cm-moves-san:hover {\n  background: rgba(255, 255, 255, 0.07);\n}\n\n.cm-moves-san--black {\n  color: rgba(232, 230, 227, 0.68);\n}\n\n.cm-moves-san--active {\n  background: rgba(129, 182, 76, 0.25);\n  color: #f7f6f2;\n}\n\n/* -- Status line -- */\n.cm-status-line {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 3px 8px;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.55);\n  background: #1f1d1a;\n  flex: 0 0 auto;\n}\n\n.cm-status-line:empty {\n  display: none;\n  padding: 0;\n}\n\n.cm-link-btn {\n  background: none;\n  border: none;\n  color: #93c5fd;\n  cursor: pointer;\n  font-size: 11px;\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n.cm-link-btn:hover {\n  background: rgba(147, 197, 253, 0.1);\n}\n\n.cm-icon-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 28px;\n  height: 28px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.08);\n  color: #f7f6f2;\n  font-size: 15px;\n}\n\n.cm-icon-pill--start {\n  background: #81b64c;\n}\n\n/* -- Action buttons: horizontal scroll row -- */\n.cm-actions {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  gap: 5px;\n  padding: 5px 8px;\n  background: #1f1d1a;\n  flex: 0 0 auto;\n  scrollbar-width: none;\n  max-width: 100%;\n  margin: 0 auto;\n  width: var(--board-size, 320px);\n}\n\n.cm-actions::-webkit-scrollbar {\n  display: none;\n}\n\n.cm-actions:empty {\n  display: none;\n  padding: 0;\n  width: auto;\n}\n\n.cm-btn {\n  flex-shrink: 0;\n  padding: 6px 11px;\n  border-radius: 7px;\n  font-size: 12px;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.15s;\n}\n\n.cm-btn--primary {\n  background: #81b64c;\n  color: #fff;\n}\n\n.cm-btn--primary:hover {\n  background: #6fa23e;\n}\n\n.cm-btn--primary:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.cm-btn--ghost {\n  background: rgba(255, 255, 255, 0.06);\n  color: rgba(255, 255, 255, 0.75);\n}\n\n.cm-btn--ghost:hover {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.cm-btn--danger {\n  background: rgba(220, 38, 38, 0.2);\n  color: #fca5a5;\n}\n\n.cm-btn--danger:hover {\n  background: rgba(220, 38, 38, 0.35);\n}\n\n.cm-btn--outline {\n  background: transparent;\n  color: rgba(255, 255, 255, 0.7);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n/* -- Review dock: bottom row (chat + ‹ LIVE ›) -- */\n.cm-review-dock {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px max(6px, env(safe-area-inset-bottom));\n  background: #1f1d1a;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  flex: 0 0 auto;\n}\n\n.cm-dock-btn {\n  position: relative;\n  flex: 1;\n  min-height: 34px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  background: rgba(255, 255, 255, 0.05);\n  color: #f7f6f2;\n  font-size: 16px;\n  font-weight: 700;\n  cursor: pointer;\n  overflow: hidden;\n}\n\n.cm-dock-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.cm-dock-btn--live {\n  font-size: 11px;\n  letter-spacing: 0.04em;\n}\n\n.cm-dock-btn--active {\n  background: #81b64c;\n  color: #fff;\n}\n\n.cm-dock-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  min-width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  background: #ef4444;\n  color: #fff;\n  font-size: 9px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 4px;\n}\n\n/* -- Small-screen tightening -- */\n@media (max-width: 480px) {\n  .cm-topbar {\n    min-height: 36px;\n    padding: 3px 6px;\n  }\n\n  .cm-icon-btn {\n    width: 28px;\n    height: 28px;\n    font-size: 14px;\n  }\n\n  .cm-topbar-title {\n    font-size: 12px;\n  }\n\n  .cm-player-bar {\n    height: 46px;\n    padding: 5px 8px;\n  }\n\n  .cm-player-bar__avatar {\n    width: 24px;\n    height: 24px;\n    font-size: 14px;\n  }\n\n  .cm-player-bar__name {\n    font-size: 12px;\n    max-width: 110px;\n  }\n\n  .cm-clock {\n    font-size: 15px;\n    min-width: 60px;\n    padding: 3px 7px;\n  }\n\n  .cm-btn {\n    font-size: 11px;\n    padding: 5px 9px;\n  }\n\n  .cm-dock-btn {\n    min-height: 30px;\n    font-size: 14px;\n  }\n\n  .cm-moves-strip {\n    min-height: 24px;\n    padding: 3px 6px;\n  }\n\n  .cm-game-stack {\n    width: 100%;\n    max-width: 100%;\n    padding: 0;\n    overflow-x: hidden;\n  }\n\n  .cm-board-wrap {\n    max-width: calc(100vw - 8px);\n    width: var(--board-size, 320px);\n    margin: 0 auto;\n  }\n\n  .cm-player-bar {\n    max-width: calc(100vw - 8px);\n    width: var(--board-size, 320px);\n    margin: 0 auto;\n  }\n\n  .cm-moves-strip {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n\n  .cm-actions {\n    max-width: 100%;\n    overflow-x: auto;\n  }\n}\n\n@media (max-width: 360px) {\n  .cm-player-bar {\n    height: 44px;\n    padding: 4px 6px;\n  }\n\n  .cm-player-bar__avatar {\n    width: 22px;\n    height: 22px;\n    font-size: 13px;\n  }\n\n  .cm-player-bar__name {\n    font-size: 11px;\n    max-width: 90px;\n  }\n\n  .cm-clock {\n    font-size: 14px;\n    min-width: 54px;\n    padding: 2px 6px;\n  }\n\n  .cm-btn {\n    font-size: 10px;\n    padding: 4px 8px;\n  }\n\n  .chess-match-page {\n    align-items: center;\n    padding: 0;\n  }\n\n  .cm-game-stack {\n    width: 100%;\n    padding: 0;\n  }\n\n  .cm-board-wrap,\n  .cm-player-bar,\n  .cm-moves-strip,\n  .cm-actions {\n    max-width: calc(100vw - 8px);\n    width: var(--board-size, 280px);\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n/* -- Spotlight (shared with flappy) -- */\n.flappy-start-spotlight,\n.cm-start-spotlight {\n  display: grid;\n  justify-items: center;\n  gap: 8px;\n  margin: 10px auto;\n  padding: 10px 12px;\n  max-width: 300px;\n  text-align: center;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.10);\n  background:\n    radial-gradient(circle at top, rgba(251, 191, 36, 0.13), transparent 56%),\n    rgba(255, 255, 255, 0.03);\n  box-shadow: 0 10px 24px rgba(0, 0, 0, 0.16);\n}\n\n.flappy-start-spotlight__title,\n.cm-start-spotlight__title {\n  font-size: 0.84rem;\n  font-weight: 800;\n  color: rgba(255, 255, 255, 0.94);\n}\n\n.flappy-start-spotlight__sub,\n.cm-start-spotlight__sub {\n  font-size: 0.72rem;\n  line-height: 1.35;\n  color: rgba(233, 236, 239, 0.72);\n}\n\n.flappy-start-spotlight .flappy-btn-primary,\n.cm-start-spotlight .cm-btn--primary {\n  min-width: min(160px, 100%);\n  padding: 8px 14px;\n  font-size: 0.83rem;\n  font-weight: 700;\n  border-radius: 999px;\n}\n\n@media (max-width: 600px) {\n\n  .flappy-start-spotlight,\n  .cm-start-spotlight {\n    margin: 8px auto;\n    padding: 9px 11px;\n  }\n\n  .cm-start-spotlight .cm-btn--primary {\n    width: auto;\n    min-width: 140px;\n  }\n}\n\n/* Legacy layout stubs */\n.chess-layout,\n.chess-panel,\n.chess-board-panel,\n.chess-board-shell,\n.chess-board-inner,\n.chess-mobile-timer,\n.chess-info-panel,\n.chess-moves-panel {}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
